export const VIEW_CERTIFICATE_OF_TRAINING = 'view-certificate-of-training';
export const VIEW_CE_CERTIFICATE = 'view-ce-certificate';

export const CERTIFICATE_LAYOUT = {
     CERTIFICATE_OF_TRAINING: 'Certificate of Training',
     CE_CERTIFICATE: 'CE Certificate',
     CAMS_TRAINED_CERTIFICATE: 'CAMS Trained Certificate',
     CAMS_CERTIFIED_CERTIFICATE: 'CAMS Certified Certificate',
};

export const CERTIFICATE_LAYOUTS = [
     {
          id: 'Certificate of Training',
          name: 'Certificate of Training',
          imageSrc: '/assets/images/certificates/certificate-of-training.jpg',
     },
     {
          id: 'CE Certificate',
          name: 'CE Certificate',
          imageSrc: '/assets/images/certificates/ce-certificate.jpg',
     },
     {
          id: 'CAMS Trained Certificate',
          name: 'CAMS Trained Certificate',
          imageSrc: '/assets/images/certificates/template-cams-trained-certificate.jpg',
     },
     {
          id: 'CAMS Certified Certificate',
          name: 'CAMS Certified Certificate',
          imageSrc: '/assets/images/certificates/template-cams-certified-certificate.jpg',
     },
];
